import { render } from "./CargaDocumentos.vue?vue&type=template&id=e2c250b6&scoped=true"
import script from "./CargaDocumentos.vue?vue&type=script&lang=js"
export * from "./CargaDocumentos.vue?vue&type=script&lang=js"

import "./CargaDocumentos.vue?vue&type=style&index=0&id=e2c250b6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c250b6"]])

export default __exports__